import ShopLayout from "../../components/signup/shop-layout";
import UploadImage from "../../components/signup/upload-national-image";
import { useLocation } from "react-router-dom";

export default function ShopUploadImage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = Number(queryParams.get("type"));
  return (
    <ShopLayout
      type={type}
      step={type === 40 ? 7 : 6}
      steps={type === 40 ? [5, 6, 7] : [4, 5, 6]}
    >
      <UploadImage isShop={true} />
    </ShopLayout>
  );
}
